<template>
<div class="chapter">
<div class="inner_page">
<div class="img" id="pic1">
<img alt="" class="calibre6" id="id-4922091315955511206" src="Images/img0001.jpg"/>
<p class="caption">IT WAS THE LAST SHOT. AS HE FIRED IT LARRY LEAPED TO ONE SIDE TO ESCAPE THE LION’S CLAWS.</p>
</div>
<div class="calibre2" id="Page_iii" title="iii"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?1f63bec4